import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface TrialStatus {
  isTrialing: boolean;
  isExpired: boolean;
  hasPaidPlan: boolean;
  daysRemaining: number;
  trialEndsAt: string | null;
  planType: string;
}

export function useTrialStatus() {
  return useQuery({
    queryKey: ['billing', 'trial'],
    queryFn: async () => {
      const response = await api.get<TrialStatus>('/billing/trial');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });
}
